import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import { bool, string, func } from 'prop-types'

import * as spacing from 'styles/spacing'
import { greyDark } from 'styles/colors'
import { fontWeights } from 'styles/typography'

const Container = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.small} ${spacing.xLarge};
  width: 100%;
  text-align: left;
  align-items: center;
  cursor: pointer;
  color: ${greyDark};

  ${props =>
    props.isBold &&
    css`
      font-weight: ${fontWeights.medium};
    `}
`

const MobileNavItem = ({ label, link, hideNav, isBold, ...rest }) => (
  <Container to={link} onClick={hideNav} isBold={isBold} {...rest}>
    {label}
  </Container>
)

MobileNavItem.propTypes = {
  label: string.isRequired,
  link: string,
  hideNav: func,
  isBold: bool
}

export default MobileNavItem
